import styled, { css } from 'styled-components';

import Text from '../Text';

export const Container = styled.div`
  width: 100%;
  margin-bottom: 1.5rem;
`;

export const Control = styled.div`
  align-items: center;
  background-color: #fff;
  border: 1px solid #e5eaee;
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  outline: 0 !important;
  position: relative;
  transition: all 100ms;
  font-family: Poppins;
  font-size: 14px;
  letter-spacing: 0.02em;

  ${({ error }) =>
    error &&
    css`
      border-color: #f64e60;
    `};

  @media (max-width: 768px) {
    height: 50px;
  }
`;

export const IndicatorsContainer = styled.div`
  position: absolute;
  right: 0;
  top: 1px;
  background-color: #fff;
  border-left: 1px solid #e5eaee;

  ${({ hasError }) =>
    hasError &&
    css`
      border-color: #f64e60 !important;
    `};
`;

export const Label = styled.label`
  margin-bottom: 10px;
  font-size: 13px;
`;

export const ErrorText = styled(Text)`
  margin-bottom: 5px;
  ${props =>
    props.color === 'error' &&
    css`
      color: #f64e60 !important;
    `};
`;

export const ValueContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  padding: 0.275rem 0.75rem;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
`;

export const MultiValue = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2px;
  min-width: 0;
  box-sizing: border-box;
  background-color: #e3e4e7;
  border-radius: 15px;
  padding: 5px 8px;
`;

export const MultiValueRemove = styled.button`
  align-items: center;
  display: flex;
  margin-left: 5px;
  background-color: transparent;
  padding: 0 3px;
`;
